'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeFormatValidator;
function makeFormatValidator(pattern, defaultMessage) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var message = options.message;
    return function (input) {
      if (!pattern.test(input)) {
        return message || defaultMessage || 'must match the pattern: ' + String(pattern);
      }
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../flow-runtime-validators/lib/makeFormatValidator.js
// module id = 295
// module chunks = 0